import { z } from "zod";
import { workflows } from "../workflows/catalog";
export const githubConnectionInput = z.object({
  id: z.string().optional(),
  name: z.string().trim().min(1).optional(),
  token: z.string().trim().max(1000).default(""),
});
export const githubRepositoryInput = z.object({
  fullName: z.string().regex(/^[\w.-]+\/[\w.-]+$/),
  integrationId: z.string().min(1),
});
export const githubRepositorySchema = z.object({
  id: z.string(),
  fullName: z.string(),
  integrationId: z.string(),
  enabled: z.boolean(),
});
export const githubWorkflowKey = z.enum(
  workflows
    .filter((workflow) => workflow.key !== "reddit.sync_subreddit")
    .map((workflow) => workflow.key),
);
